export default __webpack_public_path__ + "static/media/payment-fail.82b8eb47.svg";